import React from 'react';
import './contentStyle.scss';
import { Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { listLanguage } from '../../../../../configs/LanguageConfig';

class ContactContentSetting extends React.Component {
  renderCustomService = () => {
    const { locale } = this.props;
    const link =
      locale === listLanguage.en
        ? 'https://web.fiintrade.vn/en/faqs/'
        : 'https://web.fiintrade.vn/cau-hoi-thuong-gap/';

    return (
      <div className="row-content">
        <div className="wrap-row-notification">
          <span className="title-span w-100">
            <Translate
              value={`systemSetting.listTitleContact.customerService`}
            />
          </span>
          <div className="wrap-row">
            <span className="title-contact">
              <Translate
                value={`systemSetting.listTitleContact.customerServicesPage`}
              />
            </span>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-green"
            >
              {link}
            </a>
          </div>
        </div>
        <div className="line-dotted" />
      </div>
    );
  };

  renderUserData = () => {
    const { userInfo } = this.props;

    return (
      <div className="row-content">
        <div className="wrap-row-notification">
          <span className="title-span w-100">
            <Translate value={`systemSetting.listTitleContact.userData`} />
          </span>
          <div className="wrap-row">
            <span className="title-contact">
              <Translate
                value={`systemSetting.listTitleContact.lastLoginAttempt`}
              />
            </span>
            <span>
              {userInfo && userInfo.profile && userInfo.profile.last_attempt}
            </span>
          </div>
        </div>
        <div className="line-dotted" />
      </div>
    );
  };

  render() {
    return (
      <div className="setting-system-popup">
        {this.renderCustomService()}
        {this.renderUserData()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userInfo: state.userInfo,
    locale: state.i18n.locale,
  };
};

export default connect(mapStateToProps)(ContactContentSetting);
